import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "cm_cookie_consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          data-testid="cookie-banner"
          className="fixed bottom-0 inset-x-0 z-[100] px-4 pb-4"
        >
          <div className="max-w-3xl mx-auto bg-[#0A192F] text-white rounded-3xl shadow-[0_20px_60px_rgba(10,25,47,0.4)] border border-white/10 p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <Cookie className="w-6 h-6 text-[#10B981] shrink-0" />
            <p className="text-sm text-slate-300 leading-relaxed flex-1">
              Usiamo solo cookie tecnici e statistiche anonime per far funzionare e migliorare il sito.
              Nessuna pubblicità, nessuna vendita dei dati di navigazione. Dettagli nella{" "}
              <a href="/cookie-policy" className="font-semibold text-white underline underline-offset-2 hover:text-[#10B981] transition-colors">
                Cookie Policy
              </a>.
            </p>
            <div className="flex gap-2.5 shrink-0">
              <button
                onClick={() => choose("necessari")}
                data-testid="cookie-necessary-button"
                className="rounded-full border border-white/25 text-white text-xs font-bold px-4 py-2.5 hover:bg-white/10 transition-colors"
              >
                Solo necessari
              </button>
              <button
                onClick={() => choose("accetta")}
                data-testid="cookie-accept-button"
                className="rounded-full bg-[#10B981] text-[#0A192F] text-xs font-extrabold px-5 py-2.5 hover:bg-emerald-400 transition-colors"
              >
                Accetta
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
